import Enum from 'enum'

export const region = new Enum({
  'UNKNOWN': 0,
  'US': 1,
  'EU': 2
})

export default {
  0: 'UNKNOWN',
  1: 'US',
  2: 'EU',
  3: 'AU',
  4: 'RU'
}
